import axios from 'axios';

export interface EmployeeCreateData {
    FirstName: string;
    LastName: string;
    Email: string;
    PhoneNumber?: string;
    Address?: string;
    City?: string;
    PostalCode?: string;
    Position: string;
    SchedulerColor?: string;
    DateOfBirth?: string | Date;
    HireDate?: string | Date;
    Active?: boolean;
}

export interface EmployeeUpdateData {
    FirstName?: string;
    LastName?: string;
    Email?: string;
    PhoneNumber?: string;
    Address?: string;
    City?: string;
    PostalCode?: string;
    Position?: string;
    SchedulerColor?: string;
    DateOfBirth?: string | Date;
    HireDate?: string | Date;
    Active?: boolean;
}

/** Convert any date value (Date object, string, etc.) to ISO 8601 or null. */
function toIsoOrNull(value: unknown): string | null {
    if (value == null || value === '') return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value.toISOString();
    if (typeof value === 'string') {
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d.toISOString();
    }
    return null;
}

function sanitize<T extends Record<string, unknown>>(data: T): T {
    return { ...data, DateOfBirth: toIsoOrNull(data.DateOfBirth), HireDate: toIsoOrNull(data.HireDate) } as T;
}

export async function createEmployee(data: EmployeeCreateData, token: string): Promise<{ Oid: string }> {
    const res = await axios.post('/api/Employee/Create', sanitize(data as any), getHeaders(token));
    return res.data;
}

export async function updateEmployee(oid: string, data: EmployeeUpdateData, token: string): Promise<void> {
    await axios.put(`/api/Employee/Update/${oid}`, sanitize(data as any), getHeaders(token));
}

export async function deleteEmployee(oid: string, token: string): Promise<void> {
    await axios.delete(`/api/Employee/Delete/${oid}`, getHeaders(token));
}

const getHeaders = (token: string) => {
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    };
};
